export enum dispatchType {
    // Overlays
    OVERLAYS_OPEN = 'OVERLAYS_OPEN',
    OVERLAYS_CLOSE = 'OVERLAYS_CLOSE',
}
